import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import UIButton from '../UIComponents/UIButton';
import UIContainer from '../UIComponents/UIContainer';
import HubspotWrapper from './HubspotWrapper';
import { adminUrl, redirectNonce } from '../../constants/leadinConfig';
import { pluginPath } from '../../constants/leadinConfig';
import { __ } from '@wordpress/i18n';
function redirectToPlugin() {
    window.location.href = `${adminUrl}admin.php?page=leadin&leadin_expired=${redirectNonce}`;
}
export default function ErrorHandler({ status, resetErrorState, errorInfo = { header: '', message: '', action: '' }, }) {
    const isUnauthorized = status === 401 || status === 403;
    const errorHeader = isUnauthorized
        ? __("Your plugin isn't authorized", 'leadin')
        : errorInfo.header;
    const errorMessage = isUnauthorized
        ? __('Reauthorize your plugin to access your free HubSpot tools', 'leadin')
        : errorInfo.message;
    return (_jsx(HubspotWrapper, { pluginPath: pluginPath, children: _jsxs(UIContainer, { textAlign: "center", children: [_jsx("h4", { children: errorHeader }), _jsx("p", { children: _jsx("b", { children: errorMessage }) }), isUnauthorized ? (_jsx(UIButton, { "data-test-id": "authorize-button", onClick: redirectToPlugin, children: __('Go to plugin', 'leadin') })) : (_jsx(UIButton, { "data-test-id": "retry-button", onClick: resetErrorState, children: errorInfo.action }))] }) }));
}
